/** @prettier */
import { connect } from 'react-redux';

import { dismissNotification } from '@xanadu/ui-shared/modules/application/actions';

import Notification from '../../components/Notification';

const mapDispatchToProps = {
  dismiss: dismissNotification,
};

function mapStateToProps(state) {
  return {
    notification: state.getIn(['application', 'notification']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
